import { render, staticRenderFns } from "./giftcards-mine.vue?vue&type=template&id=1ccc16e3&scoped=true&lang=html&"
import script from "./giftcards-mine.vue?vue&type=script&lang=js&"
export * from "./giftcards-mine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc16e3",
  null
  
)

export default component.exports